var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 10.4146V21.588C29.3307 25.3346 27.6107 27.9079 24.5841 28.8813C23.7041 29.1879 22.6907 29.3346 21.5841 29.3346H10.4107C9.30406 29.3346 8.29073 29.1879 7.41073 28.8813C4.38406 27.9079 2.66406 25.3346 2.66406 21.588V10.4146C2.66406 5.5613 5.55739 2.66797 10.4107 2.66797H21.5841C26.4374 2.66797 29.3307 5.5613 29.3307 10.4146Z",
    fill: "#12B16E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.5874 28.8783C23.7074 29.185 22.6941 29.3317 21.5874 29.3317H10.4141C9.3074 29.3317 8.29406 29.185 7.41406 28.8783C7.88073 25.3583 11.5607 22.625 16.0007 22.625C20.4407 22.625 24.1207 25.3583 24.5874 28.8783Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7732 15.4413C20.7732 18.0813 18.6399 20.2279 15.9999 20.2279C13.3599 20.2279 11.2266 18.0813 11.2266 15.4413C11.2266 12.8013 13.3599 10.668 15.9999 10.668C18.6399 10.668 20.7732 12.8013 20.7732 15.4413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.310aea7da56363fbd7e6df1569c64de6.svg";
export { ForwardRef as ReactComponent };